import { message } from 'antd';
import axios from 'axios';
import { Investment, Investor, queries } from 'procura-shared';
import i18n from '../../i18n';
import { config } from '../firebase';
import * as auth from './auth';
import * as investments from './investments';
import * as investors from './investors';
import * as tests from './tests';

export const t = i18n.t.bind(i18n);

export const post = async (method: string, data: any = {}) =>
  axios.post(`${config.apiEndpoint}/${method}`, data, { headers: { 'Content-Type': 'application/json' } });

export const messagedCall = (method: Promise<any>, loading: string, success: string, error: string): Promise<any> =>
  new Promise(async (resolve, reject) => {
    const hideMessage = message.loading(t(loading), 0);
    try {
      const response = await method;
      hideMessage();
      message.success(t(success));
      resolve(response?.data);
    } catch (err) {
      hideMessage();
      const error = err.response?.data?.message ?? err.message ?? err;
      message.error(t(error, { error }), 3);
      reject(error);
    }
  });

export const updateDetails = async (details: Investor | Investment): Promise<any> => {
  const isInvestor = (await queries.investorQuery(details.id).get()).exists;
  if (isInvestor) {
    return investors.updateInvestor(details as Investor);
  } else {
    const isInvestment = (await queries.investmentQuery(details.id).get()).exists;
    if (isInvestment) {
      return investments.updateInvestment(details as Investment);
    }
  }
  return;
};

let calls = {
  investors,
  investments,
  auth,
  tests,
  updateDetails,
};

export default calls;
